export default "__VITE_ASSET__DRoANRC1__"